import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Clock from 'react-live-clock';
// import Search from '../../components/Search';
import { withMenu } from '../../modules/Menu';
import { normalize } from '../../utils/search';
import { withUser } from '../../modules/User';

class AppTopbar extends Component {
  static defaultProps = {
    onMenuButtonClick: null,
    onTopbarMenuButtonClick: null,
    onTopbarItemClick: null,
    profileMode: null,
    horizontal: false,
    topbarMenuActive: false,
    activeTopbarItem: null
  }

  static propTypes = {
    onMenuButtonClick: PropTypes.func.isRequired,
    onTopbarMenuButtonClick: PropTypes.func.isRequired,
    onTopbarItemClick: PropTypes.func.isRequired,
    profileMode: PropTypes.string.isRequired,
    horizontal: PropTypes.bool.isRequired,
    topbarMenuActive: PropTypes.bool.isRequired,
    activeTopbarItem: PropTypes.string
  }

  onTopbarItemClick(event, item) {
    if(this.props.onTopbarItemClick) {
      this.props.onTopbarItemClick({
        originalEvent: event,
        item: item
      });
    }
  }

  handleSearch = async (inputValue) => {
    const { menuOptions } = this.props;
    const options = menuOptions.filter(
      ({ label }) => normalize(label).includes(normalize(inputValue))
    );
    return options;
  }

  navigateTo = (link) => {
    if (!link) return;
    const { history } = this.props;
    history.push({ pathname: link.value });
  }

  handleRenewAuthorities = async () => {
    const { renewAuthorities } = this.props;
    await renewAuthorities();
    window.location.reload();
  }

  handleLogout = () => {
    this.props.logout();
  }

  render() {
    const { user, currentPageName } = this.props;
    const topbarItemsClassName = classNames('topbar-items fadeInDown', {'topbar-items-visible': this.props.topbarMenuActive});
    if(!this.props.isLogged) { return ( <React.Fragment/> ) }
    return (
      <div className="topbar clearfix">
        <div 
          className="topbar-left"
          style={{ padding: "10px 15px" }}
        >
          <img 
            alt="Logotipo Vortex" 
            src="assets/images/logos/vortex-logo-512px.png" 
            style={{ width: "40px", filter: "drop-shadow(5px 5px 7px rgba(0, 0, 0, 0.3))", float: "left" }}
          />
          <div
            // 
          >
            <img 
              alt="Logomarca Vortex" 
              src="assets/images/logos/logo-vortex-nome.png" 
              style={{ width: "90px", filter: "drop-shadow(5px 5px 7px rgba(0, 0, 0, 0.3))" }}
            />
            <div
              
            >
              <p
                style={{ color: "#FFF", fontSize: "10px", margin: "2.5px 5px", float: "left" }}
              >
                Powered by
              </p>  
              <img 
                alt="Logotipo Elemental" 
                src="assets/images/logos/elemental-logo-branco-250px.png" 
                style={{ width: "70px" }}
              />
            </div>
          </div>
        </div>

        <div className="topbar-right">
          <button
            className="p-link"
            id="menu-button"
            onClick={this.props.onMenuButtonClick}
          >
            <i className="fa fa-angle-left" />
          </button>
          <button className="p-link" id="topbar-menu-button" onClick={this.props.onTopbarMenuButtonClick}>
            <i className="fa fa-bars"></i>
          </button>
          <div id="topbar-page-name">
            {currentPageName}
          </div>
          <ul className={topbarItemsClassName}>
            {
              (this.props.profileMode === 'top' || this.props.horizontal)
              && user
              && (
                <li
                  className={
                    classNames(
                      'profile-item',
                      {'active-top-menu': this.props.activeTopbarItem === 'profile'}
                    )
                  }
                  onClick={(e) => this.onTopbarItemClick(e, 'profile')}
                >
                  <button className="p-link">
                    <img alt="User" className="profile-image" src="assets/layout/images/abrange.png" />
                    <span className="topbar-item-name">{user.username}</span>{' '}
                    <span className="topbar-item-role">{user.representativeId}</span>
                  </button>
                  <ul className="layout-menu fadeInDown">
                    {/* <li role="menuitem">
                      <button
                        className="p-link"
                        onClick={this.handleRenewAuthorities}
                      >
                        <i className="fa fa-fw fa-sync"></i>
                        <span>Atualizar permissões</span>
                      </button>
                    </li> */}
                    <li role="menuitem">
                      <button
                        className="p-link"
                        onClick={this.handleLogout}
                      >
                        <i className="fa fa-fw fa-sign-out"></i>
                        <span>Sair</span>
                      </button>
                    </li>
                  </ul>
                </li>
              )
            }
            <li
              className={
                classNames(
                  { 'active-top-menu': this.props.activeTopbarItem === 'settings' }
                )
              }
              onClick={(e) => this.onTopbarItemClick(e, 'settings')}
            >
              {/* <button className="p-link">
                <i className="topbar-icon fa fa-fw fa-cog"></i>
                <span className="topbar-item-name">Settings</span>
              </button> */}
              <ul className="layout-menu fadeInDown">
                { this.props.menuLayouts.map(({ label, command }) => (
                  <li key={label.toString()} role="menuitem">
                    <button className="p-link" onClick={command}>
                      {/* <i className="fa fa-fw fa-paint-brush"></i> */}
                      <span>{label}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </li>
            <li
              className={
                classNames(
                  { 'active-top-menu': this.props.activeTopbarItem === 'messages' }
                )
              }
              // onClick={(e) => this.onTopbarItemClick(e, 'messages')}
            >
              <button className="p-link">
                <i className="topbar-icon fa fa-fw fa-envelope-o"></i>
                {/* <span className="topbar-badge">5</span> */}
                <span className="topbar-item-name">Messages</span>
              </button>
              <ul className="layout-menu fadeInDown">
                {/* <li role="menuitem">
                  <button className="p-link topbar-message">
                    <img alt="Avatar 1" src="assets/layout/images/avatar1.png" width="35"/>
                    <span>Give me a call</span>
                  </button>
                </li>
                <li role="menuitem">
                  <button className="p-link topbar-message">
                    <img alt="Avatar 2" src="assets/layout/images/avatar2.png" width="35"/>
                    <span>Sales reports attached</span>
                  </button>
                </li>
                <li role="menuitem">
                  <button className="p-link topbar-message">
                    <img alt="Avatar 3" src="assets/layout/images/avatar3.png" width="35"/>
                    <span>About your invoice</span>
                  </button>
                </li>
                <li role="menuitem">
                  <button className="p-link topbar-message">
                    <img alt="Avatar 4" src="assets/layout/images/avatar2.png" width="35"/>
                    <span>Meeting today at 10pm</span>
                  </button>
                </li>
                <li role="menuitem">
                  <button className="p-link topbar-message">
                    <img alt="Avatar 5" src="assets/layout/images/avatar4.png" width="35"/>
                    <span>Out of office</span>
                  </button>
                </li> */}
              </ul>
            </li>
              <li
                className={
                  classNames(
                    {
                      'active-top-menu': this.props.activeTopbarItem === 'notifications'
                    }
                  )
                }
                // onClick={(e) => this.onTopbarItemClick(e, 'notifications')}
              >
                <button className="p-link">
                  <i className="topbar-icon fa fa-fw fa-bell-o" />
                  {/* <span className="topbar-badge animated rubberBand">4</span> */}
                  <span className="topbar-item-name">Notifications</span>
                </button>
                <ul className="layout-menu fadeInDown">
                </ul>
              </li>
              {/* <li
                className={
                  classNames(
                    'search-item',
                    {
                      'active-top-menu': this.props.activeTopbarItem === 'search'
                    },
                  )
                }
                onClick={(e) => this.onTopbarItemClick(e, 'search')}
              >
                <div className="topbar-search" style={{ minWidth: '200px' }}>
                  <Search
                    placeholder="Pesquisar"
                    loadOptions={this.handleSearch}
                    onChange={this.navigateTo}
                    // value={search}
                    isDisabled={false}
                  />
                </div>
              </li> */}
              <li>
                <div className="topbar-clock">
                  <i className="fa fa-fw fa-clock" />
                  <Clock
                    format="HH:mm"
                    ticking
                  />
                </div>
              </li>
            </ul>
        </div>
      </div>
    );
  }
}

export default withUser(withMenu(withRouter(AppTopbar)));
